import panel_year_range_vue_vue_type_script_setup_true_lang_default from "./panel-year-range.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/panel-year-range.vue
var panel_year_range_default = panel_year_range_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_year_range_default as default };
//# sourceMappingURL=panel-year-range.mjs.map